
































































































































































































































































import {
  AgeAgeDTO,
  AgeManagerService,
  EventManagementCreateEventItemRequest,
  SettingManagementCreateSettingRequest,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import QPaginate from "@/common/qEventItemPaginate.vue";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import PaginateModel from "@/model/paginate";
import { PropType } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "EventItemsComponent",
  components: { QInputMultipleLanguage, QErrors, QPaginate },
  computed: {
    SettingManagementCreateSettingRequest() {
      return SettingManagementCreateSettingRequest;
    },
  },
})
export default class EventItemsComponent extends Vue {

  get eventItems() {
    this.pagination.pageCount = Math.ceil(
      this.value.length / this.pagination.end,
    );
    this.pagination.count = this.value.length;
    const start = (this.pagination.page - 1) * this.pagination.end;
    const end = start + this.pagination.end;

    return this.value.slice(start, end);
  }

  get startIndex() {
    return (this.pagination.page - 1) * this.pagination.end;
  }
  public name: "EventItemsComponent";

  @Prop({
    type: Object,
    default: {
      ja: true,
      en: true,
      cn: false,
    },
  })
  public languages;

  @Prop({
    type: Array as PropType<EventManagementCreateEventItemRequest[]>,
    default() {
      return [
        {
          id: null,
          eventId: null,
          code: "",
          producer: "",
          producerEn: "",
          producerCn: "",
          kind: "",
          kindEn: "",
          kindCn: "",
          ageId: null,
          sex: "",
          size: null,
          parent: "",
          parentEn: "",
          parentCn: "",
          price: null,
          isBidding: false,
          note: "",
          noteEn: "",
          noteCn: "",
          status: EventManagementCreateEventItemRequest.status.RELEASE,
        },
      ];
    },
  })
  public value;

  @Prop({
    type: Object,
    default: {},
  })
  public errors;

  @Prop({
    type: Function,
  })
  public clearError;

  public ages: AgeAgeDTO[] = [];
  public gender = [
    {
      id: "male",
      name: this.translateAttribute("event_preview.male"),
    },
    {
      id: "female",
      name: this.translateAttribute("event_preview.female"),
    },
    {
      id: "unknown",
      name: this.translateAttribute("event_preview.unknown"),
    },
    {
      id: "female_now",
      name: this.translateAttribute("event_preview.female_now"),
    },
  ];

  public pagination = new PaginateModel({
    page: 1,
    pageCount: 0,
    start: 1,
    end: 100,
    count: 0,
  });

  public mounted() {
    this.getListAge();
    this.pagination.page =
      Number.parseInt(this.$router.currentRoute.query.page as string) || 1;
  }

  public addEventItem() {
    this.value.push({
      id: null,
      eventId: null,
      code: "",
      producer: "",
      producerEn: "",
      producerCn: "",
      kind: "",
      kindEn: "",
      kindCn: "",
      ageId: null,
      sex: EventManagementCreateEventItemRequest.sex.UNKNOWN,
      size: null,
      parent: "",
      parentEn: "",
      parentCn: "",
      price: null,
      isBidding: false,
      note: "",
      noteEn: "",
      noteCn: "",
      status: EventManagementCreateEventItemRequest.status.RELEASE,
    });
    this.pagination.page = Math.ceil(this.value.length / this.pagination.end);
    this.pagination.count = this.value.length;
    this.doSearch({ page: this.pagination.page }, false);
  }

  public removeEventItem(index) {
    this.value.splice(index, 1);
    if (
      Math.ceil(this.value.length / this.pagination.end) < this.pagination.page
    ) {
      this.pagination.page = this.pagination.page - 1;
    }
    this.pagination.count = this.value.length;
    this.doSearch({ page: this.pagination.page }, false);
  }

  public translateAttribute(attributeName) {
    const currentLang = LANG.JA;
    return this.$t(attributeName, `${currentLang}`);
  }

  public doSearch(query: any = {}, scrollToTop = true): void {
    query = {
      ...query,
    };
    this.pagination.page = query.page || 1;
    this.pagination = new PaginateModel({
      page: this.pagination.page,
      pageCount: this.pagination.pageCount,
      start: this.pagination.start,
      end: this.pagination.end,
      count: this.pagination.count,
    });

    this.$router.push({ query }).catch(() => {
      //
    });
    if (scrollToTop) {
      this.$nextTick(() => {
        const eventItemsElement = this.$refs.eventItemsElement as HTMLElement;
        eventItemsElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      });
    }
  }
  public getPageError(errors) {
    if (errors) {
      const keysWithNumbers = Object.keys(errors).filter((key) =>
        key.match(/\d+/),
      );
      const sortedKeys = keysWithNumbers?.sort((a, b) => {
        const numberA = Number.parseInt(a.match(/\d+/)[0]);
        const numberB = Number.parseInt(b.match(/\d+/)[0]);
        return numberA - numberB;
      });
      const firstKeySorted = sortedKeys[0];
      const eventItemIndex = Number.parseInt(firstKeySorted?.match(/\d+/)[0]);
      const page = Math.ceil((eventItemIndex + 1) / this.pagination.end);
      if (page) {
        this.doSearch({ page }, false);
      }
    }
  }

  private async getListAge() {
    const result = await AgeManagerService.adminAge({});

    this.ages = result.data.ages;
  }
}
